import React from 'react'

export default function AddCampusAdmin() {
    return (
        <div>
            add new campus AddCampusAdmin
        </div>
    )
}
